module.exports = __webpack_public_path__ + "img/icon-understand-your-event.50ff46d6.png";